import { App as CapacitorApp } from '@capacitor/app';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import type { PluginListenerHandle } from '@capacitor/core';

import { DevicesQRCodeLinkKey } from '../components/Devices/constants';
import { QRCodeDeviceId, RefreshToken, Token } from '../constants/keys';
import { PathnamesMap } from '../constants/ui';

export function useDeepLinks(): void {
  const navigate = useNavigate();

  useEffect(() => {
    const handleDeepLink = (url: string) => {
      console.log('Deep link received:', url);

      try {
        // Поддержка как custom scheme (croplerapp://), так и https://
        // const parsed = new URL(url.replace('croplerapp://', 'https://app.cropler.io/'));
        const parsed = new URL(url);
        const deviceNumber = parsed.searchParams.get(DevicesQRCodeLinkKey);

        // if QR-code url
        if (parsed.pathname === `/${PathnamesMap.devices}` && deviceNumber) {
          localStorage.setItem(QRCodeDeviceId, deviceNumber);
          const accessToken = localStorage.getItem(Token);
          const refreshToken = localStorage.getItem(RefreshToken);
          const isAuthenticated = !!accessToken && !!refreshToken;

          if (isAuthenticated) {
            navigate(`/devices?${DevicesQRCodeLinkKey}=${deviceNumber}`);
          } else {
            // sessionStorage.setItem('redirect_after_login', `/devices?${DevicesQRCodeLinkKey}=${deviceNumber}`);
            navigate('/login');
          }
        }
      } catch (error) {
        console.error('Error parsing deep link:', error);
      }
    };

    let listenerHandle: PluginListenerHandle | undefined;

    // Слушатель для открытия по ссылке когда приложение уже запущено
    CapacitorApp.addListener('appUrlOpen', ({ url }) => {
      handleDeepLink(url);
    }).then((handle) => {
      listenerHandle = handle;
    });

    // Проверка при первой загрузке (если приложение открылось по ссылке)
    // CapacitorApp.getLaunchUrl().then(({ url }) => {
    //   if (url) {
    //     handleDeepLink(url);
    //   }
    // });

    return () => {
      if (listenerHandle) {
        listenerHandle.remove();
      }
    };
  }, [navigate]);
}
